module.exports = __webpack_public_path__ + "img/img1.546928e4.svg";